export enum HEALTH_PLAN_TYPE {
  ALL = 'all',
  ACTIVE = 'active',
  IN_ACTIVE = 'inactive'
}
